"use strict";

module.exports = {
    "user2": {
        "add-account": "Аккаунтты қосу",
        "edit-accounts": "Тізімді өңдеу",
        "enter": "Кіру",
        "exit": "Шығу",
        "help": "Көмек",
        "mail": ["жаңа хат", "жаңа хат", "", ""],
        "mail_compose": "Хат жазу",
        "passport": "Аккаунтты басқару",
        "settings": "Баптаулар",
        "upload_files": "Менің дискім"
    }
};